import { createAction, props } from "@ngrx/store";
import { IClientState } from "./client.models";

export const setClient = createAction(
  '[Client] Set Client data',
  props<{ clientData: IClientState }>()
);